import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top on route (path) changes but NOT when only the language
 * segment (/ar <-> /en) at the start of the path changes.
 */
export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const stripLang = (p) => {
      const parts = p.split("/").filter(Boolean);
      if (parts[0] === "ar" || parts[0] === "en") return "/" + parts.slice(1).join("/");
      return p;
    };

    const key = "__zantravika_last_path";
    const currentStripped = stripLang(pathname);
    const previous = sessionStorage.getItem(key);

    if (previous !== currentStripped) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
    sessionStorage.setItem(key, currentStripped);
  }, [pathname]);
}
